"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactFulcrum = require("@upgrowth/react-fulcrum");

var _loading = require("./loading.svg");

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

exports.default = function () {
  return React.createElement(_reactFulcrum.Flex, {
    className: "Loading"
  }, React.createElement("img", {
    src: _loading2.default
  }));
};